module.exports = __webpack_public_path__ + "img/imgDestaqueLeft.84f258bf.jpg";